import { useState } from "react";
import "./Slides.css";

const slides = [
  {
    id: 1,
    type: "cover",
    title: "Plateforme DevSecOps",
    subtitle: "Azure Kubernetes Service",
    author: "Stayer Arsel DIFFO SOUOP",
    school: "SUPINFO Paris — Master 2 — 2025/2026",
    tag: "MASTER 2 — SUPINFO",
    live: "http://20.87.90.91",
    github: "github.com/ARSEL123",
  },
  {
    id: 2,
    type: "sommaire",
    title: "Sommaire",
    items: [
      { num: "01", label: "Contexte et objectifs" },
      { num: "02", label: "Architecture technique" },
      { num: "03", label: "Phase 1 — Infrastructure as Code" },
      { num: "04", label: "Phase 2 — CI/CD et Kubernetes" },
      { num: "05", label: "Phase 3 — Supervision" },
      { num: "06", label: "Phase 4 — Haute dispo et tests" },
      { num: "07", label: "Resultats et competences" },
    ],
  },
  {
    id: 3,
    type: "content",
    title: "Contexte et objectifs",
    num: "01",
    color: "#1F4E79",
    question: "Comment deployer une infrastructure cloud complete, securisee et automatisee ?",
    cols: [
      { title: "Infrastructure", color: "#1F4E79", items: ["Terraform + Ansible", "Azure AKS + ACR", "VM Ubuntu securisee"] },
      { title: "Automatisation", color: "#0D9488", items: ["Pipeline CI/CD 4 jobs", "Tests automatiques", "Deploiement continu"] },
      { title: "Supervision", color: "#22C55E", items: ["Prometheus + Grafana", "ELK Stack", "Alerting temps reel"] },
    ],
    stack: ["Terraform","Ansible","Docker","Kubernetes","GitHub Actions","Trivy","Prometheus","Grafana"],
  },
  {
    id: 4,
    type: "architecture",
    title: "Architecture technique",
    num: "02",
    steps: [
      { label: "git push", color: "#374151" },
      { label: "GitHub Actions", color: "#1F4E79" },
      { label: "Docker Build", color: "#2E75B6" },
      { label: "Trivy Scan", color: "#F59E0B" },
      { label: "Push ACR", color: "#0D9488" },
      { label: "Deploy AKS", color: "#22C55E" },
    ],
    blocs: [
      { title: "Azure VM", desc: "Ubuntu 22.04\nStandard_B2als_v2\nAnsible configure", color: "#2E75B6" },
      { title: "Azure AKS", desc: "2 pods Flask\nLoad Balancer\nIP: 20.87.90.91", color: "#0D9488" },
      { title: "Supervision", desc: "Prometheus + Grafana\nELK Stack\nAlerting actif", color: "#1F4E79" },
    ],
  },
  {
    id: 5,
    type: "phase",
    title: "Phase 1 — Infrastructure as Code",
    num: "03",
    color: "#0D9488",
    left: {
      title: "Terraform — 9 ressources Azure",
      color: "#1F4E79",
      items: ["Resource Group","Virtual Network + Subnet","Network Security Group","IP Publique Standard SKU","VM Ubuntu 22.04","Azure Container Registry","AKS Cluster","Storage Account + Container"],
    },
    right: {
      title: "Ansible — 21 taches, 0 erreur",
      color: "#0D9488",
      items: ["Role base : paquets + user deploy","Role security : UFW ports 22/80/443","Role docker : Docker CE 29.3.0","SSH hardening (no password auth)","Interdiction login root"],
    },
    stat: { val1: "21", lbl1: "taches executees", val2: "0", lbl2: "erreur" },
  },
  {
    id: 6,
    type: "cicd",
    title: "Phase 2 — CI/CD et Kubernetes",
    num: "04",
    color: "#22C55E",
    jobs: [
      { num: "1", title: "Build & Test", desc: "pytest + Docker\nmulti-stage build", color: "#1F4E79", dur: "30s" },
      { num: "2", title: "Trivy Scan", desc: "Scan vulnerabilites\nCRITICAL/HIGH", color: "#F59E0B", dur: "45s" },
      { num: "3", title: "Push ACR", desc: "Image Docker\nvers Azure ACR", color: "#0D9488", dur: "1min" },
      { num: "4", title: "Deploy AKS", desc: "Rolling update\nKubernetes", color: "#22C55E", dur: "2min" },
    ],
    result: { pods: "2 pods Running", ip: "http://20.87.90.91", pipeline: "4 jobs verts" },
  },
  {
    id: 7,
    type: "supervision",
    title: "Phase 3 — Supervision",
    num: "05",
    color: "#F59E0B",
    tools: [
      { name: "Prometheus", role: "Collecte metriques toutes les 15s", pods: "2/2 Running", color: "#F59E0B" },
      { name: "Grafana", role: "Dashboards visuels temps reel", pods: "3/3 Running", color: "#0D9488" },
      { name: "Alertmanager", role: "Alertes email et notifications", pods: "2/2 Running", color: "#1F4E79" },
      { name: "Elasticsearch", role: "Stockage et indexation des logs", pods: "1/1 Running", color: "#22C55E" },
      { name: "Kibana", role: "Interface visualisation logs", pods: "1/1 Running", color: "#2E75B6" },
      { name: "Node Exporter", role: "Metriques systeme CPU/RAM", pods: "1/1 Running", color: "#374151" },
    ],
  },
  {
    id: 8,
    type: "resultats",
    title: "Resultats et indicateurs",
    num: "07",
    stats: [
      { val: "12", label: "Ressources\nAzure actives", color: "#1F4E79" },
      { val: "0%", label: "Erreurs HTTP\nsous 50 VUs", color: "#22C55E" },
      { val: "395ms", label: "Latence p95\nseuil 500ms", color: "#0D9488" },
      { val: "4 jobs", label: "Pipeline CI/CD\n100% verts", color: "#F59E0B" },
    ],
    skills: [
      "Terraform — Provisionnement IaC Azure",
      "GitHub Actions — Pipelines CI/CD",
      "Kubernetes AKS — Rolling updates",
      "Docker — Multi-stage builds",
      "Prometheus / Grafana — Dashboards",
      "ELK Stack — Logs centralises",
      "Ansible — Roles et hardening",
      "k6 — Tests de charge",
    ],
  },
  {
    id: 9,
    type: "conclusion",
    title: "Merci pour votre attention",
    author: "Stayer Arsel DIFFO SOUOP",
    email: "diffoarsel123@gmail.com",
    tel: "07 59 38 19 27",
    school: "Master of Engineering — Systemes, Reseaux & Cloud",
    live: "http://20.87.90.91",
    github: "github.com/ARSEL123/devsecops-platform",
  },
];

function SlideRenderer({ slide }) {
  if (slide.type === "cover") return (
    <div className="slide slide-cover">
      <div className="cover-accent"></div>
      <div className="cover-content">
        <span className="cover-tag">{slide.tag}</span>
        <h1>{slide.title}</h1>
        <h2>{slide.subtitle}</h2>
        <div className="cover-divider"></div>
        <p className="cover-author">{slide.author}</p>
        <p className="cover-school">{slide.school}</p>
        <div className="cover-links">
          <a href={slide.live} target="_blank" rel="noreferrer" className="cover-btn-live">LIVE : {slide.live}</a>
          <span className="cover-btn-gh">{slide.github}</span>
        </div>
      </div>
    </div>
  );

  if (slide.type === "sommaire") return (
    <div className="slide slide-light">
      <div className="slide-header navy"><h2>{slide.title}</h2></div>
      <div className="sommaire-grid">
        {slide.items.map((item, i) => (
          <div className="sommaire-item" key={i}>
            <span className="sommaire-num" style={{background: i % 2 === 0 ? "#1F4E79" : "#0D9488"}}>{item.num}</span>
            <span className="sommaire-label">{item.label}</span>
          </div>
        ))}
      </div>
    </div>
  );

  if (slide.type === "content") return (
    <div className="slide slide-light">
      <div className="slide-header" style={{background: slide.color}}><h2>{slide.num} — {slide.title}</h2></div>
      <div className="content-question">{slide.question}</div>
      <div className="content-cols">
        {slide.cols.map((col, i) => (
          <div className="content-col" key={i}>
            <div className="content-col-header" style={{background: col.color}}>{col.title}</div>
            <div className="content-col-body">
              {col.items.map((item, j) => <div className="content-col-item" key={j}>• {item}</div>)}
            </div>
          </div>
        ))}
      </div>
      <div className="stack-badges">
        {slide.stack.map((t, i) => <span className="stack-badge" key={i}>{t}</span>)}
      </div>
    </div>
  );

  if (slide.type === "architecture") return (
    <div className="slide slide-gray">
      <div className="slide-header navy"><h2>{slide.num} — {slide.title}</h2></div>
      <div className="arch-steps">
        {slide.steps.map((step, i) => (
          <div className="arch-step-wrap" key={i}>
            <div className="arch-step" style={{background: step.color}}>{step.label}</div>
            {i < slide.steps.length - 1 && <div className="arch-arrow">→</div>}
          </div>
        ))}
      </div>
      <div className="arch-blocs">
        {slide.blocs.map((bloc, i) => (
          <div className="arch-bloc" key={i}>
            <div className="arch-bloc-header" style={{background: bloc.color}}>{bloc.title}</div>
            <div className="arch-bloc-body">
              {bloc.desc.split("\n").map((line, j) => <div key={j}>{line}</div>)}
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  if (slide.type === "phase") return (
    <div className="slide slide-light">
      <div className="slide-header" style={{background: slide.color}}><h2>{slide.num} — {slide.title}</h2></div>
      <div className="phase-cols">
        <div className="phase-col">
          <div className="phase-col-header" style={{background: slide.left.color}}>{slide.left.title}</div>
          <ul className="phase-list">{slide.left.items.map((item, i) => <li key={i}>{item}</li>)}</ul>
        </div>
        <div className="phase-col">
          <div className="phase-col-header" style={{background: slide.right.color}}>{slide.right.title}</div>
          <ul className="phase-list">{slide.right.items.map((item, i) => <li key={i}>{item}</li>)}</ul>
          <div className="phase-stat">
            <span className="phase-stat-val" style={{color:"#22C55E"}}>{slide.stat.val1}</span>
            <span className="phase-stat-lbl"> {slide.stat.lbl1}  </span>
            <span className="phase-stat-val" style={{color:"#0D9488"}}>{slide.stat.val2}</span>
            <span className="phase-stat-lbl"> {slide.stat.lbl2}</span>
          </div>
        </div>
      </div>
    </div>
  );

  if (slide.type === "cicd") return (
    <div className="slide slide-light">
      <div className="slide-header" style={{background: slide.color}}><h2>{slide.num} — {slide.title}</h2></div>
      <div className="cicd-jobs">
        {slide.jobs.map((job, i) => (
          <div className="cicd-job" key={i}>
            <div className="cicd-job-header" style={{background: job.color}}>Job {job.num}</div>
            <div className="cicd-job-title" style={{color: job.color}}>{job.title}</div>
            <div className="cicd-job-desc">{job.desc.split("\n").map((l,j) => <div key={j}>{l}</div>)}</div>
            <div className="cicd-job-dur" style={{borderColor: job.color, color: job.color}}>{job.dur}</div>
          </div>
        ))}
      </div>
      <div className="cicd-result">
        <span><strong>{slide.result.pods}</strong></span>
        <span>|</span>
        <span>IP : <strong>{slide.result.ip}</strong></span>
        <span>|</span>
        <span>Pipeline : <strong>{slide.result.pipeline}</strong></span>
      </div>
    </div>
  );

  if (slide.type === "supervision") return (
    <div className="slide slide-light">
      <div className="slide-header" style={{background: slide.color}}><h2>{slide.num} — {slide.title}</h2></div>
      <div className="superv-grid">
        {slide.tools.map((tool, i) => (
          <div className="superv-card" key={i} style={{borderLeftColor: tool.color}}>
            <div className="superv-name" style={{color: tool.color}}>{tool.name}</div>
            <div className="superv-role">{tool.role}</div>
            <span className="superv-badge">{tool.pods}</span>
          </div>
        ))}
      </div>
    </div>
  );

  if (slide.type === "resultats") return (
    <div className="slide slide-light">
      <div className="slide-header navy"><h2>{slide.num} — {slide.title}</h2></div>
      <div className="res-stats">
        {slide.stats.map((stat, i) => (
          <div className="res-stat" key={i} style={{background: stat.color}}>
            <div className="res-stat-val">{stat.val}</div>
            <div className="res-stat-lbl">{stat.label.split("\n").map((l,j)=><div key={j}>{l}</div>)}</div>
          </div>
        ))}
      </div>
      <h3 className="res-skills-title">Competences acquises</h3>
      <div className="res-skills">
        {slide.skills.map((skill, i) => (
          <div className="res-skill" key={i}>
            <span className="res-skill-dot" style={{background: i%2===0?"#0D9488":"#1F4E79"}}></span>
            {skill}
          </div>
        ))}
      </div>
    </div>
  );

  if (slide.type === "conclusion") return (
    <div className="slide slide-cover">
      <div className="cover-accent"></div>
      <div className="cover-content">
        <h1 style={{fontSize:"2rem"}}>{slide.title}</h1>
        <div className="cover-divider"></div>
        <p className="cover-author">{slide.author}</p>
        <p>{slide.email} | {slide.tel}</p>
        <p className="cover-school">{slide.school}</p>
        <div className="cover-links" style={{marginTop:"1.5rem"}}>
          <a href={slide.live} target="_blank" rel="noreferrer" className="cover-btn-live">Application Live</a>
          <a href={"https://"+slide.github} target="_blank" rel="noreferrer" className="cover-btn-gh">{slide.github}</a>
        </div>
      </div>
    </div>
  );

  return null;
}

export default function Slides({ onClose }) {
  const [current, setCurrent] = useState(0);
  const prev = () => setCurrent(c => Math.max(0, c - 1));
  const next = () => setCurrent(c => Math.min(slides.length - 1, c + 1));

  return (
    <div className="slides-overlay">
      <div className="slides-modal">
        <div className="slides-topbar">
          <span className="slides-title">Presentation DevSecOps — Arsel DIFFO SOUOP</span>
          <div className="slides-controls">
            <span className="slides-counter">{current + 1} / {slides.length}</span>
            <button onClick={onClose} className="slides-close">✕ Fermer</button>
          </div>
        </div>
        <div className="slides-viewport">
          <SlideRenderer slide={slides[current]} />
        </div>
        <div className="slides-nav">
          <button onClick={prev} disabled={current === 0} className="slides-btn">← Precedent</button>
          <div className="slides-dots">
            {slides.map((_, i) => (
              <button key={i} onClick={() => setCurrent(i)}
                className={"slides-dot" + (i === current ? " active" : "")} />
            ))}
          </div>
          <button onClick={next} disabled={current === slides.length - 1} className="slides-btn">Suivant →</button>
        </div>
      </div>
    </div>
  );
}
